type StoredDefinition = Record<string, unknown>;

type MigrationStep = (definition: StoredDefinition) => StoredDefinition;

const migrationSteps: MigrationStep[] = [];

export const CURRENT_FORMAT_VERSION = 1;

export const migrate = (definition: StoredDefinition, version: number): StoredDefinition => {
  return migrationSteps.slice(version - 1).reduce((migrated, step) => step(migrated), definition);
};
